// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/api/organizations/deactivations/firstparty/v4/closing_reason_details.proto

/* oxlint-disable */

/**
 * Wrapper message scoping ClosingReasonDetail to avoid enum value name
 * collisions with ClosingReasonSubCategory at the package level (proto uses
 * C++ scoping rules where enum values share the enclosing scope).
 */
export interface ApiClosingReasonDetails {
}

/**
 * Represents leaf-level closing reason details.
 * Source: OrganizationDeactivations::Models::Reasons::CLIENT_REASONS (detail arrays).
 */
export const ApiClosingReasonDetailsClosingReasonDetail = {
  /** CLOSING_REASON_DETAIL_UNSPECIFIED - No closing reason detail specified. */
  CLOSING_REASON_DETAIL_UNSPECIFIED: "CLOSING_REASON_DETAIL_UNSPECIFIED",
  /**
   * other - Other detail reason.
   */
  other: "other",
  /**
   * poor_value_for_money - Poor value for money.
   */
  poor_value_for_money: "poor_value_for_money",
  /**
   * features_not_available_on_my_plan - Features not available on current plan.
   */
  features_not_available_on_my_plan: "features_not_available_on_my_plan",
  /**
   * pay_for_features_not_used - Paying for features not used.
   */
  pay_for_features_not_used: "pay_for_features_not_used",
  /**
   * cannot_afford_price_plan - Cannot afford the price plan.
   */
  cannot_afford_price_plan: "cannot_afford_price_plan",
  /**
   * optional_addon_fees - Optional add-on fees.
   */
  optional_addon_fees: "optional_addon_fees",
  /**
   * transfer_fees - Transfer fees.
   */
  transfer_fees: "transfer_fees",
  /**
   * card_fees - Card fees.
   */
  card_fees: "card_fees",
  /**
   * foreign_exchange_fees - Foreign exchange fees.
   */
  foreign_exchange_fees: "foreign_exchange_fees",
  /**
   * withdrawal_limits - Withdrawal limits.
   */
  withdrawal_limits: "withdrawal_limits",
  /**
   * card_delivery_issues - Card delivery issues.
   */
  card_delivery_issues: "card_delivery_issues",
  /**
   * card_not_working - Card not working.
   */
  card_not_working: "card_not_working",
  /**
   * transfer_delays - Transfer delays.
   */
  transfer_delays: "transfer_delays",
  /**
   * transfer_limit_too_low - Transfer limit too low.
   */
  transfer_limit_too_low: "transfer_limit_too_low",
  /**
   * international_transfer_issues - International transfer issues.
   */
  international_transfer_issues: "international_transfer_issues",
  /**
   * usage_experience - Usage experience issues.
   */
  usage_experience: "usage_experience",
  /**
   * technical_issues - Technical issues.
   */
  technical_issues: "technical_issues",
  /**
   * issues_with_login - Issues with login.
   */
  issues_with_login: "issues_with_login",
  /**
   * hard_to_reach_support - Hard to reach support.
   */
  hard_to_reach_support: "hard_to_reach_support",
  /**
   * issues_not_solved - Issues not solved by support.
   */
  issues_not_solved: "issues_not_solved",
  /**
   * victim_of_fraud - Victim of fraud.
   */
  victim_of_fraud: "victim_of_fraud",
  /**
   * safety_concerns - Safety concerns.
   */
  safety_concerns: "safety_concerns",
  /**
   * loan_solution - Loan solution.
   */
  loan_solution: "loan_solution",
  /**
   * overdraft - Overdraft.
   */
  overdraft: "overdraft",
  /**
   * credit_card - Credit card.
   */
  credit_card: "credit_card",
  /**
   * took_out_with_competitor - Took out financing with a competitor.
   */
  took_out_with_competitor: "took_out_with_competitor",
  /**
   * sepa_direct_debits - SEPA direct debits.
   */
  sepa_direct_debits: "sepa_direct_debits",
  /**
   * international_transfers - International transfers.
   */
  international_transfers: "international_transfers",
  /**
   * checkbook - Checkbook.
   */
  checkbook: "checkbook",
  /**
   * local_payments - Local payment methods.
   */
  local_payments: "local_payments",
  /**
   * payment_terminal - Payment terminal.
   */
  payment_terminal: "payment_terminal",
  /**
   * cash_deposit - Cash deposit options.
   */
  cash_deposit: "cash_deposit",
  /**
   * accountant_tools - Accountant tools integration.
   */
  accountant_tools: "accountant_tools",
  /**
   * tax_reporting_tools - Tax reporting tools integration.
   */
  tax_reporting_tools: "tax_reporting_tools",
  /**
   * payroll_systems - Payroll systems integration.
   */
  payroll_systems: "payroll_systems",
  /**
   * accounting_codes - Accounting codes.
   */
  accounting_codes: "accounting_codes",
  /**
   * accounting_exports - Accounting export formats.
   */
  accounting_exports: "accounting_exports",
  /**
   * accounting_api - Accounting API.
   */
  accounting_api: "accounting_api",
  /**
   * low_interest_rate - Low interest rate on account balance.
   */
  low_interest_rate: "low_interest_rate",
  /**
   * investment_options - Investment options.
   */
  investment_options: "investment_options",
  /**
   * business_savings_account - Business savings account.
   */
  business_savings_account: "business_savings_account",
  /**
   * remuneration_account_with_competitor - Found a remunerated account with a competitor.
   */
  remuneration_account_with_competitor: "remuneration_account_with_competitor",
  /**
   * foreign_currencies_fee - Foreign currencies fee.
   */
  foreign_currencies_fee: "foreign_currencies_fee",
} as const;

export type ApiClosingReasonDetailsClosingReasonDetail =
  typeof ApiClosingReasonDetailsClosingReasonDetail[keyof typeof ApiClosingReasonDetailsClosingReasonDetail];

export namespace ApiClosingReasonDetailsClosingReasonDetail {
  export type CLOSING_REASON_DETAIL_UNSPECIFIED =
    typeof ApiClosingReasonDetailsClosingReasonDetail.CLOSING_REASON_DETAIL_UNSPECIFIED;
  export type other = typeof ApiClosingReasonDetailsClosingReasonDetail.other;
  export type poor_value_for_money = typeof ApiClosingReasonDetailsClosingReasonDetail.poor_value_for_money;
  export type features_not_available_on_my_plan =
    typeof ApiClosingReasonDetailsClosingReasonDetail.features_not_available_on_my_plan;
  export type pay_for_features_not_used = typeof ApiClosingReasonDetailsClosingReasonDetail.pay_for_features_not_used;
  export type cannot_afford_price_plan = typeof ApiClosingReasonDetailsClosingReasonDetail.cannot_afford_price_plan;
  export type optional_addon_fees = typeof ApiClosingReasonDetailsClosingReasonDetail.optional_addon_fees;
  export type transfer_fees = typeof ApiClosingReasonDetailsClosingReasonDetail.transfer_fees;
  export type card_fees = typeof ApiClosingReasonDetailsClosingReasonDetail.card_fees;
  export type foreign_exchange_fees = typeof ApiClosingReasonDetailsClosingReasonDetail.foreign_exchange_fees;
  export type withdrawal_limits = typeof ApiClosingReasonDetailsClosingReasonDetail.withdrawal_limits;
  export type card_delivery_issues = typeof ApiClosingReasonDetailsClosingReasonDetail.card_delivery_issues;
  export type card_not_working = typeof ApiClosingReasonDetailsClosingReasonDetail.card_not_working;
  export type transfer_delays = typeof ApiClosingReasonDetailsClosingReasonDetail.transfer_delays;
  export type transfer_limit_too_low = typeof ApiClosingReasonDetailsClosingReasonDetail.transfer_limit_too_low;
  export type international_transfer_issues =
    typeof ApiClosingReasonDetailsClosingReasonDetail.international_transfer_issues;
  export type usage_experience = typeof ApiClosingReasonDetailsClosingReasonDetail.usage_experience;
  export type technical_issues = typeof ApiClosingReasonDetailsClosingReasonDetail.technical_issues;
  export type issues_with_login = typeof ApiClosingReasonDetailsClosingReasonDetail.issues_with_login;
  export type hard_to_reach_support = typeof ApiClosingReasonDetailsClosingReasonDetail.hard_to_reach_support;
  export type issues_not_solved = typeof ApiClosingReasonDetailsClosingReasonDetail.issues_not_solved;
  export type victim_of_fraud = typeof ApiClosingReasonDetailsClosingReasonDetail.victim_of_fraud;
  export type safety_concerns = typeof ApiClosingReasonDetailsClosingReasonDetail.safety_concerns;
  export type loan_solution = typeof ApiClosingReasonDetailsClosingReasonDetail.loan_solution;
  export type overdraft = typeof ApiClosingReasonDetailsClosingReasonDetail.overdraft;
  export type credit_card = typeof ApiClosingReasonDetailsClosingReasonDetail.credit_card;
  export type took_out_with_competitor = typeof ApiClosingReasonDetailsClosingReasonDetail.took_out_with_competitor;
  export type sepa_direct_debits = typeof ApiClosingReasonDetailsClosingReasonDetail.sepa_direct_debits;
  export type international_transfers = typeof ApiClosingReasonDetailsClosingReasonDetail.international_transfers;
  export type checkbook = typeof ApiClosingReasonDetailsClosingReasonDetail.checkbook;
  export type local_payments = typeof ApiClosingReasonDetailsClosingReasonDetail.local_payments;
  export type payment_terminal = typeof ApiClosingReasonDetailsClosingReasonDetail.payment_terminal;
  export type cash_deposit = typeof ApiClosingReasonDetailsClosingReasonDetail.cash_deposit;
  export type accountant_tools = typeof ApiClosingReasonDetailsClosingReasonDetail.accountant_tools;
  export type tax_reporting_tools = typeof ApiClosingReasonDetailsClosingReasonDetail.tax_reporting_tools;
  export type payroll_systems = typeof ApiClosingReasonDetailsClosingReasonDetail.payroll_systems;
  export type accounting_codes = typeof ApiClosingReasonDetailsClosingReasonDetail.accounting_codes;
  export type accounting_exports = typeof ApiClosingReasonDetailsClosingReasonDetail.accounting_exports;
  export type accounting_api = typeof ApiClosingReasonDetailsClosingReasonDetail.accounting_api;
  export type low_interest_rate = typeof ApiClosingReasonDetailsClosingReasonDetail.low_interest_rate;
  export type investment_options = typeof ApiClosingReasonDetailsClosingReasonDetail.investment_options;
  export type business_savings_account = typeof ApiClosingReasonDetailsClosingReasonDetail.business_savings_account;
  export type remuneration_account_with_competitor =
    typeof ApiClosingReasonDetailsClosingReasonDetail.remuneration_account_with_competitor;
  export type foreign_currencies_fee = typeof ApiClosingReasonDetailsClosingReasonDetail.foreign_currencies_fee;
}

export function apiClosingReasonDetailsClosingReasonDetailFromJSON(
  object: any,
): ApiClosingReasonDetailsClosingReasonDetail {
  switch (object) {
    case 0:
    case "CLOSING_REASON_DETAIL_UNSPECIFIED":
      return ApiClosingReasonDetailsClosingReasonDetail.CLOSING_REASON_DETAIL_UNSPECIFIED;
    case 1:
    case "other":
      return ApiClosingReasonDetailsClosingReasonDetail.other;
    case 2:
    case "poor_value_for_money":
      return ApiClosingReasonDetailsClosingReasonDetail.poor_value_for_money;
    case 3:
    case "features_not_available_on_my_plan":
      return ApiClosingReasonDetailsClosingReasonDetail.features_not_available_on_my_plan;
    case 4:
    case "pay_for_features_not_used":
      return ApiClosingReasonDetailsClosingReasonDetail.pay_for_features_not_used;
    case 5:
    case "cannot_afford_price_plan":
      return ApiClosingReasonDetailsClosingReasonDetail.cannot_afford_price_plan;
    case 6:
    case "optional_addon_fees":
      return ApiClosingReasonDetailsClosingReasonDetail.optional_addon_fees;
    case 7:
    case "transfer_fees":
      return ApiClosingReasonDetailsClosingReasonDetail.transfer_fees;
    case 8:
    case "card_fees":
      return ApiClosingReasonDetailsClosingReasonDetail.card_fees;
    case 9:
    case "foreign_exchange_fees":
      return ApiClosingReasonDetailsClosingReasonDetail.foreign_exchange_fees;
    case 10:
    case "withdrawal_limits":
      return ApiClosingReasonDetailsClosingReasonDetail.withdrawal_limits;
    case 11:
    case "card_delivery_issues":
      return ApiClosingReasonDetailsClosingReasonDetail.card_delivery_issues;
    case 12:
    case "card_not_working":
      return ApiClosingReasonDetailsClosingReasonDetail.card_not_working;
    case 13:
    case "transfer_delays":
      return ApiClosingReasonDetailsClosingReasonDetail.transfer_delays;
    case 14:
    case "transfer_limit_too_low":
      return ApiClosingReasonDetailsClosingReasonDetail.transfer_limit_too_low;
    case 15:
    case "international_transfer_issues":
      return ApiClosingReasonDetailsClosingReasonDetail.international_transfer_issues;
    case 16:
    case "usage_experience":
      return ApiClosingReasonDetailsClosingReasonDetail.usage_experience;
    case 17:
    case "technical_issues":
      return ApiClosingReasonDetailsClosingReasonDetail.technical_issues;
    case 18:
    case "issues_with_login":
      return ApiClosingReasonDetailsClosingReasonDetail.issues_with_login;
    case 19:
    case "hard_to_reach_support":
      return ApiClosingReasonDetailsClosingReasonDetail.hard_to_reach_support;
    case 20:
    case "issues_not_solved":
      return ApiClosingReasonDetailsClosingReasonDetail.issues_not_solved;
    case 21:
    case "victim_of_fraud":
      return ApiClosingReasonDetailsClosingReasonDetail.victim_of_fraud;
    case 22:
    case "safety_concerns":
      return ApiClosingReasonDetailsClosingReasonDetail.safety_concerns;
    case 23:
    case "loan_solution":
      return ApiClosingReasonDetailsClosingReasonDetail.loan_solution;
    case 24:
    case "overdraft":
      return ApiClosingReasonDetailsClosingReasonDetail.overdraft;
    case 25:
    case "credit_card":
      return ApiClosingReasonDetailsClosingReasonDetail.credit_card;
    case 26:
    case "took_out_with_competitor":
      return ApiClosingReasonDetailsClosingReasonDetail.took_out_with_competitor;
    case 27:
    case "sepa_direct_debits":
      return ApiClosingReasonDetailsClosingReasonDetail.sepa_direct_debits;
    case 28:
    case "international_transfers":
      return ApiClosingReasonDetailsClosingReasonDetail.international_transfers;
    case 29:
    case "checkbook":
      return ApiClosingReasonDetailsClosingReasonDetail.checkbook;
    case 30:
    case "local_payments":
      return ApiClosingReasonDetailsClosingReasonDetail.local_payments;
    case 31:
    case "payment_terminal":
      return ApiClosingReasonDetailsClosingReasonDetail.payment_terminal;
    case 32:
    case "cash_deposit":
      return ApiClosingReasonDetailsClosingReasonDetail.cash_deposit;
    case 33:
    case "accountant_tools":
      return ApiClosingReasonDetailsClosingReasonDetail.accountant_tools;
    case 34:
    case "tax_reporting_tools":
      return ApiClosingReasonDetailsClosingReasonDetail.tax_reporting_tools;
    case 35:
    case "payroll_systems":
      return ApiClosingReasonDetailsClosingReasonDetail.payroll_systems;
    case 36:
    case "accounting_codes":
      return ApiClosingReasonDetailsClosingReasonDetail.accounting_codes;
    case 37:
    case "accounting_exports":
      return ApiClosingReasonDetailsClosingReasonDetail.accounting_exports;
    case 38:
    case "accounting_api":
      return ApiClosingReasonDetailsClosingReasonDetail.accounting_api;
    case 39:
    case "low_interest_rate":
      return ApiClosingReasonDetailsClosingReasonDetail.low_interest_rate;
    case 40:
    case "investment_options":
      return ApiClosingReasonDetailsClosingReasonDetail.investment_options;
    case 41:
    case "business_savings_account":
      return ApiClosingReasonDetailsClosingReasonDetail.business_savings_account;
    case 42:
    case "remuneration_account_with_competitor":
      return ApiClosingReasonDetailsClosingReasonDetail.remuneration_account_with_competitor;
    case 43:
    case "foreign_currencies_fee":
      return ApiClosingReasonDetailsClosingReasonDetail.foreign_currencies_fee;
    default:
      return ApiClosingReasonDetailsClosingReasonDetail.CLOSING_REASON_DETAIL_UNSPECIFIED;
  }
}

export function apiClosingReasonDetailsClosingReasonDetailToJSON(
  object: ApiClosingReasonDetailsClosingReasonDetail,
): string {
  switch (object) {
    case ApiClosingReasonDetailsClosingReasonDetail.CLOSING_REASON_DETAIL_UNSPECIFIED:
      return "CLOSING_REASON_DETAIL_UNSPECIFIED";
    case ApiClosingReasonDetailsClosingReasonDetail.other:
      return "other";
    case ApiClosingReasonDetailsClosingReasonDetail.poor_value_for_money:
      return "poor_value_for_money";
    case ApiClosingReasonDetailsClosingReasonDetail.features_not_available_on_my_plan:
      return "features_not_available_on_my_plan";
    case ApiClosingReasonDetailsClosingReasonDetail.pay_for_features_not_used:
      return "pay_for_features_not_used";
    case ApiClosingReasonDetailsClosingReasonDetail.cannot_afford_price_plan:
      return "cannot_afford_price_plan";
    case ApiClosingReasonDetailsClosingReasonDetail.optional_addon_fees:
      return "optional_addon_fees";
    case ApiClosingReasonDetailsClosingReasonDetail.transfer_fees:
      return "transfer_fees";
    case ApiClosingReasonDetailsClosingReasonDetail.card_fees:
      return "card_fees";
    case ApiClosingReasonDetailsClosingReasonDetail.foreign_exchange_fees:
      return "foreign_exchange_fees";
    case ApiClosingReasonDetailsClosingReasonDetail.withdrawal_limits:
      return "withdrawal_limits";
    case ApiClosingReasonDetailsClosingReasonDetail.card_delivery_issues:
      return "card_delivery_issues";
    case ApiClosingReasonDetailsClosingReasonDetail.card_not_working:
      return "card_not_working";
    case ApiClosingReasonDetailsClosingReasonDetail.transfer_delays:
      return "transfer_delays";
    case ApiClosingReasonDetailsClosingReasonDetail.transfer_limit_too_low:
      return "transfer_limit_too_low";
    case ApiClosingReasonDetailsClosingReasonDetail.international_transfer_issues:
      return "international_transfer_issues";
    case ApiClosingReasonDetailsClosingReasonDetail.usage_experience:
      return "usage_experience";
    case ApiClosingReasonDetailsClosingReasonDetail.technical_issues:
      return "technical_issues";
    case ApiClosingReasonDetailsClosingReasonDetail.issues_with_login:
      return "issues_with_login";
    case ApiClosingReasonDetailsClosingReasonDetail.hard_to_reach_support:
      return "hard_to_reach_support";
    case ApiClosingReasonDetailsClosingReasonDetail.issues_not_solved:
      return "issues_not_solved";
    case ApiClosingReasonDetailsClosingReasonDetail.victim_of_fraud:
      return "victim_of_fraud";
    case ApiClosingReasonDetailsClosingReasonDetail.safety_concerns:
      return "safety_concerns";
    case ApiClosingReasonDetailsClosingReasonDetail.loan_solution:
      return "loan_solution";
    case ApiClosingReasonDetailsClosingReasonDetail.overdraft:
      return "overdraft";
    case ApiClosingReasonDetailsClosingReasonDetail.credit_card:
      return "credit_card";
    case ApiClosingReasonDetailsClosingReasonDetail.took_out_with_competitor:
      return "took_out_with_competitor";
    case ApiClosingReasonDetailsClosingReasonDetail.sepa_direct_debits:
      return "sepa_direct_debits";
    case ApiClosingReasonDetailsClosingReasonDetail.international_transfers:
      return "international_transfers";
    case ApiClosingReasonDetailsClosingReasonDetail.checkbook:
      return "checkbook";
    case ApiClosingReasonDetailsClosingReasonDetail.local_payments:
      return "local_payments";
    case ApiClosingReasonDetailsClosingReasonDetail.payment_terminal:
      return "payment_terminal";
    case ApiClosingReasonDetailsClosingReasonDetail.cash_deposit:
      return "cash_deposit";
    case ApiClosingReasonDetailsClosingReasonDetail.accountant_tools:
      return "accountant_tools";
    case ApiClosingReasonDetailsClosingReasonDetail.tax_reporting_tools:
      return "tax_reporting_tools";
    case ApiClosingReasonDetailsClosingReasonDetail.payroll_systems:
      return "payroll_systems";
    case ApiClosingReasonDetailsClosingReasonDetail.accounting_codes:
      return "accounting_codes";
    case ApiClosingReasonDetailsClosingReasonDetail.accounting_exports:
      return "accounting_exports";
    case ApiClosingReasonDetailsClosingReasonDetail.accounting_api:
      return "accounting_api";
    case ApiClosingReasonDetailsClosingReasonDetail.low_interest_rate:
      return "low_interest_rate";
    case ApiClosingReasonDetailsClosingReasonDetail.investment_options:
      return "investment_options";
    case ApiClosingReasonDetailsClosingReasonDetail.business_savings_account:
      return "business_savings_account";
    case ApiClosingReasonDetailsClosingReasonDetail.remuneration_account_with_competitor:
      return "remuneration_account_with_competitor";
    case ApiClosingReasonDetailsClosingReasonDetail.foreign_currencies_fee:
      return "foreign_currencies_fee";
    default:
      return "CLOSING_REASON_DETAIL_UNSPECIFIED";
  }
}

export const ApiClosingReasonDetails: MessageFns<ApiClosingReasonDetails> = {
  fromJSON(_: any): ApiClosingReasonDetails {
    return {};
  },

  toJSON(_: ApiClosingReasonDetails): unknown {
    const obj: any = {};
    return obj;
  },
};

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
